export const validation = {
  dateLabelsMaxChar: 20,
}
